<div class="icon-menu-items">
  @if (companies?.length > 1 && !user.demo_mode) {
    <mat-select
      class="select"
      [hideSingleSelectionIndicator]="true"
      [formControl]="companiesControl"
    >
      @for (company of companies; track company) {
        <mat-option
          [value]="company.id"
          (click)="selectCompany(company.id)"
        >
          {{ company.display_name }}
        </mat-option>
      }
    </mat-select>
  }

  @if (user.demo_mode) {
    <a
      mat-flat-button
      class="start-demo-button"
      color="primary"
      href="https://app.storylane.io/share/pmnzzmvdutaq"
    >
      Start demo
    </a>
  }

  <button
    mat-icon-button
    data-test="account-menu-button"
    class="account-button"
    aria-label="Account"
    [matMenuTriggerFor]="profileMenu"
  >
    @if (!user || !user.profile_picture_url) {
      <mat-icon class="profile-pic-icon material-icons-outlined">account_circle</mat-icon>
    } @else {
      <img
        class="profile-pic-img"
        alt="profile"
        [src]="user.profile_picture_url"
      />
    }
  </button>
</div>

<mat-menu #profileMenu="matMenu">
  <a
    mat-menu-item
    data-test="profile-link"
    routerLink="/company-profile"
  >
    <mat-icon class="menu-icon">account_circle</mat-icon>
    <span>Profile</span>
  </a>
  <a
    mat-menu-item
    data-test="settings-link"
    routerLink="/user/profile"
  >
    <mat-icon class="menu-icon">settings</mat-icon>
    <span>Settings</span>
  </a>
  <a
    mat-menu-item
    data-test="logout-button"
    (click)="logout()"
  >
    <mat-icon class="menu-icon">exit_to_app</mat-icon>
    <span>Log Out</span>
  </a>
</mat-menu>
